__webpack_require__.p = "https://assets-01.periodica.press/c1479bf-21636486475/";